import SearchApiResponsePager from "@js/helpers/search-api-response-pager.es6.js";
import ArrayUtils from "@js/utils/array-utils.es6.js";

/**
 * Represents a standard Search API REST response.
 */
export default class SearchApiResponse {
  constructor(
    currentPage = 0,
    currentRows = [],
    itemsPerPage = 0,
    totalItems = 0,
    totalPages = 0,
  ) {
    this.pager = new SearchApiResponsePager(
      currentPage,
      itemsPerPage,
      totalItems,
      totalPages,
    );
    this.rows = currentRows;
  }

  /**
   * Convert an array to an object that models Search API response pages.  The results
   * include all pages made from the array.
   *
   * @param {Array<object>} array the results to build into Search API response pages
   * @param {number} itemsPerPage the number of results to include on each page
   * @throws {TypeError} if the provided array is not an instance of an Array
   * @return {Array<SearchApiResponse>} the Search API response pages
   */
  static arrayToSearchApiResponses(array, itemsPerPage) {
    const isArray = Array.isArray(array);
    if (!isArray) {
      throw new TypeError('Array must be an instance of an Array.');
    }

    if (itemsPerPage <= 0) {
      throw new Error('Items per page must be greater than zero.');
    }

    const totalItems = array.length;
    if (totalItems === 0) {
      return [new SearchApiResponse()];
    }

    const totalPages = Math.ceil(totalItems / itemsPerPage);
    const pages = [];

    const pageItems = ArrayUtils.splitArrayIntoChunks(array, itemsPerPage);
    pageItems.forEach((rows, currentPage) => {
      const page = new SearchApiResponse(
        currentPage,
        rows,
        itemsPerPage,
        totalItems,
        totalPages,
      );
      pages.push(page);
    });

    return pages;
  }
}
